export default __webpack_public_path__ + "static/smbBanner2-5d67952014d38918e4d31c3b78c8563b.png";